var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lawdettyls"},[_c('sub-title',{attrs:{"text":"特邀律师"}}),_c('div',{staticClass:"cardlist"},[_c('law-card',{staticClass:"tyitem"}),_c('law-card',{staticClass:"tyitem"}),_c('law-card',{staticClass:"tyitem"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }